import { Slide } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { useTheme } from "@mui/material/styles";
import { TransitionProps } from "@mui/material/transitions";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";



// const dialogContainer = {
//     [`.MuiDialog-container`]: {
//         alignItems: "flex-start",
//         justifyContent: "flex-end",

//         [`.MuiDialog-paper`]: {
//             margin: "20px"
//         }
//     },
// };

// const Transition = React.forwardRef(function Transition(
//     props: TransitionProps & {
//         children: React.ReactElement;
//     },
//     ref: React.Ref<unknown>,
// ) {
//     return <Slide direction="up" ref={ref} {...props} />;
// });

const Transition = React.forwardRef((props, ref) => {
    return <Slide direction="up" ref={ref} {...props} />;
});


export default function EditorsLargeModal({
    open,
    onClose,
    scroll,
    children,
    hideBackdrop,
    className,
}) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));


    return (
        <Dialog
            hideBackdrop={hideBackdrop}
            fullScreen
            open={open}
            onClose={onClose}
            scroll={scroll}
            aria-labelledby="responsive-dialog-title"
            PaperProps={{
                sx: {
                    [`& .MuiDialogContent-root`]: {
                        padding: "24px 24px 22px",
                        position: "relative"
                    },
                },
            }}
            TransitionComponent={Transition}
            className={className}
        >
            <DialogContent>{children}</DialogContent>
        </Dialog >
    );
}

